// Shared Won/Lost + on-target math for BOTH scoreboards (the in-meeting
// SectionScoreboard and the team Scoreboard page). These mirror
// Metric#on_track_for_value? / Metric#won_for_value? on the server so an
// optimistic cell update shows the same result the backend will persist.
// Keeping one copy is deliberate: a divergence between the two frontends
// (or between a frontend and the backend) silently mis-colors cells.

export function goalDirectionToComparison(goalDirection: string | null | undefined): string {
  switch (goalDirection) {
    case 'higher_is_better': return 'gte'
    case 'lower_is_better': return 'lte'
    case 'target_exact': return 'eq'
    default: return 'gte'
  }
}

export function computeOnTarget(
  value: number | null,
  target: number | null | undefined,
  goalDirection: string | null | undefined,
  comparison: string | null | undefined
): boolean | null {
  if (value === null || value === undefined || Number.isNaN(value)) return null
  if (target === null || target === undefined) return null
  const effective = comparison || goalDirectionToComparison(goalDirection)
  switch (effective) {
    case 'gte': return value >= target
    case 'lte': return value <= target
    case 'gt':  return value > target
    case 'lt':  return value < target
    case 'eq':  return value === target
    default:    return value >= target
  }
}

// Mirrors Metric#won_for_value? — a cell is WON only when the value actually
// meets the metric's target comparison (task #598). No partial credit: the
// team's win threshold is the WEEK-level rule (share of metrics on target),
// not a per-cell tolerance.
export function computeWon(
  value: number | null,
  target: number | null | undefined,
  goalDirection: string | null | undefined,
  comparison: string | null | undefined
): boolean | null {
  return computeOnTarget(value, target, goalDirection, comparison)
}
